// Wrapper Component for the Mantine TextInput
import { ChangeEvent, ReactElement } from 'react';
import {
  PasswordInput as MantinePasswordInput,
  TextInput as MantineTextInput,
} from '@mantine/core';
import styles from './TextInput.module.scss';

// Link to Mantine TextInput Component:  https://mantine.dev/core/text-input/
// Link to Mantine PasswordInput Component: https://mantine.dev/core/password-input/
type Props = {
  label: string,
  value: string,
  onChange: (event: ChangeEvent<HTMLInputElement>) => void,
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void,
  placeholder?: string,
  error?: string,
  type?: 'text' | 'password',
}

export function TextInput({
  label,
  value,
  onChange,
  onKeyDown,
  placeholder,
  error,
  type = 'text',
}: Props): ReactElement {
  return (
    <div className={styles.text_input}>
      {type === 'password' ? (
        <MantinePasswordInput
          label={label}
          placeholder={placeholder}
          value={value}
          onChange={(event) => onChange(event)}
          onKeyDown={onKeyDown}
          error={error}
          styles={{
            wrapper: {
              border: 'unset',
            },
            input: {
              border: '1px solid',
              borderColor: error ? '#FA5252' : '#DEE2E6',
              borderRadius: '4px',
              '&:focus-within': {
                borderColor: '#DEE2E6',
              },
            },
            rightSection: {
              button: {
                '&:hover': {
                  border: 'unset',
                  color: '#868E96',
                },
              },
            },
          }}
        />
      ) : (
        <MantineTextInput
          label={label}
          placeholder={placeholder}
          value={value}
          onChange={(event) => onChange(event)}
          error={error}
          styles={{
            wrapper: {
              border: '1px solid',
              borderColor: error ? '#FA5252' : '#DEE2E6',
              borderRadius: '4px',
            },
            input: {
              border: 'unset',
            },
          }}
        />
      )}
    </div>
  );
}
